<!-- eslint-disable no-extra-semi -->
<template>
  <div>
    <div v-if="noOutputs"
         class="centered-h-v">
      WAITING FOR THE VIDEO...
    </div>
    <div class="player"
         id="player"
         :hidden="hideVideo"
         v-if="!noOutputs">
      <video playsinline
             ref="videoPlayer"
             :poster="$store.getters.getPoster"
             class="
											video-js
											vjs-big-play-centered
											embed-responsive-item
							"
             v-bind:class="cmp_skin_class"></video>
    </div>
    <div v-if="getStateVideodebug"
         id="chart_container">
      <div id="legend"></div>
      <div id="legend-totals"></div>
      <div id="y_axis"></div>
      <div id="chart"></div>
    </div>
  </div>
</template>


<script>
import functions from "../lib/functions.js";
import videojs from "video.js";
import youbora from "youboralib";

require("video.js/dist/video-js.css");
require("youbora-adapter-videojs");

export default {
  name: "VideoPlayer",
  props: [
    "viewComponentKey"
  ],
  data() {
    return {
      noOutputs: false,
      player: null,
      unwatchStore: undefined,
      p2pengine: undefined,
      cueTrackActive: false,
      cueTrack: undefined,
      prevLang: this.$store.getters.getCur_lang,
      isPlaying: false,
      currentTime: 0,
      hideVideo: true,
      p2pstats: {
        download_http: 0,
        download_p2p: 0,
        upload: 0
      },
      prev_src: null,
      prev_type: null,
      flagDebugP2p: true

    };
  },
  created: function() {
    let skin = this.$store.getters.getSkin ?? "vjs-default-skin";
    if (skin != "vjs-default-skin") {
      fetch("./css/video.js/videojs-" + skin + ".css")
        .then((style) => {
          const styleElement = document.createElement("style");
          style.text().then(t => {
            styleElement.textContent = t;
            document.head.appendChild(styleElement);
            this.hideVideo = false;
          });
        });
    } else {
      this.hideVideo = false;
    }
  },
  beforeMount: function() {
    window.addEventListener("message", this.parent_msg_event_incoming, false);
  },
  mounted() {
    this.$store.commit("setIsPlayerPlaying", false);
    if (!this.$store.getters.getActive) {
      this.onNoOutputs();
      this.noOutputs = true;
      return;
    } else {
      this.noOutputs = false;
    }
    this.unwatchStore = this.$store.watch(
      (state) =>
        state.videoJSOptions.sources[0].src +
        "-" +
        state.videoJSOptions.sources[0].type +
        "-" +
        state.videoJSOptions.autoplay +
        "-" +
        state.videoJSOptions.loop +
        "-" +
        state.videoJSOptions.audioOnlyMode,
      () => {
        if (!this.$store.getters.getActive) {
          this.onNoOutputs();
          this.noOutputs = true;
          return;
        } else {
          this.noOutputs = false;
        }
        if (
          this.$store.getters.getCuePoint.layout_mode == "video" ||
          this.$store.getters.getCuePoint.layout_mode == "videoslide"
        ) {
          // eslint-disable-next-line
          if (!this.player) {
            this.player = videojs(
              this.$refs.videoPlayer,
              this.$store.getters.getVideoJSOptions
            );
            console.log("Video.js player version : " + this.player.version()["video.js"]);
          }
          this.player.responsive(true);
          if (this.player) {
            if (
              !this.prev_src
              ||
              this.prev_src != this.$store.getters.getVideoJSOptions.sources[0].src
              ||
              this.prev_type != this.$store.getters.getVideoJSOptions.sources[0].type
            ) {
              this.$store.commit("setIsPlayerPlaying", false);
              this.currentTime = this.player.currentTime();
              this.$store.commit("setIsRestart", !this.player.paused());
              this.player.src({
                src: this.$store.getters.getVideoJSOptions.sources[0].src,
                type: this.$store.getters.getVideoJSOptions.sources[0].type
              });
              this.prev_src = this.$store.getters.getVideoJSOptions.sources[0].src;
              this.prev_type = this.$store.getters.getVideoJSOptions.sources[0].type;
              if (!this.player.paused()) {
                this.player.pause();
                this.player.play();
              }
            }
            this.updateAnalytics();
          }
        }
      }
    );
    this.checkP2P().then(() => {
      this.player = videojs(
        this.$refs.videoPlayer,
        this.$store.getters.getVideoJSOptions
      );
      console.log("Video.js player version : " + this.player.version()["video.js"]);

      this.player.responsive(true);
      this.player.posterImage.hide();
      this.prev_src = this.$store.getters.getVideoJSOptions.sources[0].src;
      this.prev_type = this.$store.getters.getVideoJSOptions.sources[0].type;
      window.player = this.player;

      // handle cuepoints
      if (
        process.env.VUE_APP_DISABLE_INSIDE_STREAM_CUEPOINTS === "false"
        &&
        !this.$store.getters.get_disable_check_cuepoints
      ) {
        this.player.on("texttrackchange", this.manageCuePoints.bind(this));
      }

      //Player events
      this.player.on("play", this.onPlay.bind(this));
      this.player.on("playing", this.manageEventOnPlaying.bind(this));
      this.player.on("pause", this.onPause.bind(this));
      this.player.on("loadedmetadata", this.onLoadedmetadata.bind(this));
      this.player.on("resize", this.onResize.bind(this));
      this.player.on("timeupdate", this.onTimeUpdate.bind(this));
      this.player.on("ready", this.onReady.bind(this));

      // handle analytics
      for (let pt = 0; pt < (this.$store.getters.getAnalytics).length; pt++) {
        let analytics_item = this.$store.getters.getAnalytics[pt];
        switch (analytics_item.kind) {
          case "google":
            if (this.$gtag) {
              this.$gtag.event("PlayerOpened", {
                event_category: this.$store.getters.getCuePoint.status,
                event_label:
                this.$store.getters.getVideoJSOptions.sources[0].src,
                value: ""
              });

              this.player.on("play", () => this.gTrack("Play"));
              this.player.on("pause", () => this.gTrack("Pause"));
            }
            break;
          case "youbora": {
            const iWcacheActive = this.$store.getters.getIwcacheActive;
            const userData = this.$store.getters.getUserData;
            if (iWcacheActive) {
              this.redirectYouboraRequestToProxy();
            }
            var youboraOptions = {
              accountCode: analytics_item.attributes.accountCode
            };

            if (userData) {
              youboraOptions["user.email"] = userData.email;
              youboraOptions["content.customDimension.1"] = userData.email;
            }
            youboraOptions["app.releaseVersion"] = this.player.version()["video.js"];
            if (iWcacheActive) {
              youboraOptions["content.customDimension.3"] = this.$store.getters.getIp;
              if (window.location.hostname) {
                youboraOptions["content.customDimension.2"] = window.location.hostname
                  .split(".")[0];
              }
              youboraOptions["content.customDimension.4"] = window.engine ? this.$store.getters.getP2PConfig.p2pgroup : '-';
            }

            if (analytics_item.attributes.username && analytics_item.attributes.username != "") {
              youboraOptions.username = analytics_item.attributes.username;
            }
            this.plugin = new youbora.Plugin(youboraOptions);
            var youboraAdapter = youbora.adapters.Videojs.extend({
              getP2PTraffic: function() {
                return window.p2pstats.download_p2p;
              },
              getCdnTraffic: function() {
                return window.p2pstats.download_http;
              },
              getUploadTraffic: function() {
                return window.p2pstats.upload;
              },
              getIsP2PEnabled: function() {
                return window.engine != null;
              }
            });
            this.plugin.setAdapter(new youboraAdapter(this.player));
            this.updateAnalytics();
            break;
          }
        }
      }
    }, error => {
      console.error("errore nel check p2p", error);
    });
    window.parent.postMessage({ "type": "mounted" }, "*");
    setTimeout(() => { //se live non ho eventi onload e non aggiorna la dimensione del player
      this.onResize();
    }, 500);
  },
  updated() {
  },
  beforeUnmount() {
    window.removeEventListener(
      "message",
      this.parent_msg_event_incoming,
      false
    );
  },
  beforeDestroy() {
    if (this.unwatchStore) {
      this.unwatchStore();
    }

    if (this.player) {
      this.player.dispose();
    }
  },
  methods: {
    onNoOutputs: function() {
    },
    onResize: function() {
      // const clientWidth = document.body.clientWidth;
      // const clientHeight = document.body.clientHeight;
      //Se audioonly==false : dimensioni intero player
      let newWidth = null;
      let newHeight = null;
      if (this.$store.getters.getVideoJSOptions_audio_only_mode) {
        const elemPlayer = document.getElementById("player");
        const elemControlBar = elemPlayer?.querySelector(".vjs-control-bar");
        if (elemControlBar) {
          newWidth = elemControlBar.clientWidth;
          newHeight = elemControlBar.clientHeight;
        }
      } else {
        newWidth = document.getElementById("player")?.clientWidth;
        newHeight = document.getElementById("player")?.clientHeight;
      }
      if (newWidth && newHeight) {
        functions.sendParentResizeEvent(newWidth, newHeight);
      }
    },
    onPlay: function() {
      this.$store.commit("setIsPlayerPlaying", true);
      this.$store.commit("setIsRestart", true);
      functions.sendParentPlayerEvent("play");
    },
    onPause: function() {
      this.$store.commit("setIsPlayerPlaying", false);
      this.$store.commit("setIsRestart", false);
      functions.sendParentPlayerEvent("pause");
    },
    onLoadedmetadata: function() {
      //f you are playing a VOD and change the language, it resumes from the point where you left off.
      if (this.$store.getters.getCur_lang != this.prevLang) {
        this.player?.currentTime(this.currentTime);
      }
      //If the player was in a playing state, it automatically resumes.
      if (this.$store.getters.getIsRestart) {
        if (this.player.paused()) this.player.play();
        this.$store.commit("setIsPlayerPlaying", true);
      }
      this.prevLang = this.$store.getters.getCur_lang;
      functions.sendParentPlayerEvent("loadedmetadata");
    },
    updateAnalytics: function() {
      for (let pt = 0; pt < (this.$store.getters.getAnalytics).length; pt++) {
        let analytics_item = this.$store.getters.getAnalytics[pt];
        switch (analytics_item.kind) {
          case "youbora":
            this.plugin.setOptions({
              "content.isLive":
                this.$store.getters.getCuePoint.status == "live"
                  ? true
                  : false,
              "content.title": this.$store.getters.getTitle
            });
            break;
        }
      }
    },
    manageCuePoints: function() {
      if (!this.cueTrackActive) {
        //this.cueTrackActive = true;
        for (var x = 0; x < this.player.textTracks().length; x++) {
          const textTrackItem = this.player.textTracks()[x];

          var textTrackItemObjectId = new Date().getTime();
          textTrackItem.textTrackItemObjectId = textTrackItemObjectId;
          if (textTrackItem.kind == "captions") {
            this.cueTrack = textTrackItem;
            this.cueTrack.oncuechange = function(oncuechangeEvent) {
              var oncuechangeObjectId = new Date().getTime();
              oncuechangeEvent.oncuechangeObjectId = oncuechangeObjectId;

              if (
                oncuechangeEvent.currentTarget &&
                oncuechangeEvent.currentTarget.activeCues &&
                oncuechangeEvent.currentTarget.activeCues.length > 0
              ) {
                if (
                  this.$store.getters.getCuePoint.layout_mode ==
                  "videoslide" ||
                  this.$store.getters.getCuePoint.layout_mode ==
                  "video"
                ) {
                  const newQ =
                    oncuechangeEvent.currentTarget.activeCues[0].text.split(
                      "="
                    )[1];
                  this.$store.commit("setStatusCuepoint", newQ);
                }
              }
            }.bind(this);
            textTrackItem.mode = "hidden";
          }
        }
      }
    },
    decodeUrlParams: function(url) {
      // Usa URLSearchParams per ottenere i parametri dell'URL
      const urlObj = new URL(url);
      const params = new URLSearchParams(urlObj.search);

      // Modifica il parametro 'triggeredEvents' se esiste
      if (params.has("triggeredEvents")) {
        const triggeredEventsValue = params.get("triggeredEvents");

        // Decodifica e sostituisci il valore URL-encoded
        const decodedValue = decodeURIComponent(triggeredEventsValue)
          .replace(/%5B/g, "[") // sostituisce %5B con [
          .replace(/%22/g, "\"") // sostituisce %22 con "
          .replace(/%5D/g, "]"); // sostituisce %5D con ]

        // Aggiorna il parametro con il valore decodificato
        params.set("triggeredEvents", decodedValue);
      }

      // Ricostruisce l'URL con i parametri modificati
      urlObj.search = params.toString();
      return urlObj.toString();
    },
    replaceUrl: function(url) {
      const parsedUrl = new URL(url);
      url += "&youboraHost=" + parsedUrl.host + parsedUrl.pathname;
      url = url.replace(parsedUrl.host + parsedUrl.pathname, window.location.hostname + "/npaw");
      return url;
    },
    redirectYouboraRequestToProxy: function() {
      const originalXHR = window.XMLHttpRequest;
      const self = this;
      function newXHR() {
        const xhr = new originalXHR();
        const originalOpen = xhr.open;
        xhr.open = function(method, url, async) {
          if (/^https:\/\/(?:[A-Za-z0-9-]+\.)?youbora[a-zA-Z0-9]{5}\.com(?:[/?]|$)/.test(url)) {
            url = self.replaceUrl(url);
          }
          originalOpen.apply(this, [method, url, async]);
        };
        return xhr;
      }
      window.XMLHttpRequest = newXHR;
    },
    gTrack: function(action) {
      if (this.$gtag) {
        this.$gtag.event(action, {
          event_category: this.$store.getters.getCuePoint.status,
          event_label:
          this.$store.getters.getVideoJSOptions.sources[0].src,
          value: ""
        });
      }
    },
    manageEventOnPlaying: function() {
      this.$store.commit("setIsPlayerPlaying", true);
      functions.sendParentPlayerEvent("playing");
    },
    parent_msg_event_incoming(event) {
      switch (event.data?.type) {
        case "commandPlay":
          if (this.player.paused()) this.player.play();
          break;
        case "commandGoTo":
          this.player.pause();
          this.player.currentTime(event.data?.content.time);
          if (this.player.paused()) this.player.play();
          break;
        case "commandGoToSlide":
          if (this.$store.getters.getCuePoints) {
            const item = this.$store.getters.getCuePoints.find(i =>
              i.layout_mode == "videoslide" && i.images.file_name == event.data?.content?.file_name && i.images.group_id == event.data?.content?.group_id
            );
            if (item) {
              this.player.pause();
              this.player.currentTime(item.time);
              if (this.player.paused()) this.player.play();
            }
          }
          break;
        case "commandPause":
          this.player.pause();
          break;
        default:
          break;
      }
    },
    checkP2P() {
      return new Promise((resolve, reject) => {
        if (this.$store.getters.getP2PConfig.p2p && this.$store.getters.getP2PConfig.p2pgroup != null) {
          switch (this.$store.getters.getP2PConfig.p2ptech) {
            case "p2pmedialoader":
              window.videojs = videojs;
              this.$loadScript("./lib/p2p/p2p-media-loader-core.js").then(() => {
                this.$loadScript("./lib/p2p/p2p-media-loader-hlsjs.js").then(() => {
                  this.$loadScript("./lib/p2p/videojs-hlsjs-plugin.js").then(() => {
                    const p2pml = window.p2pml;
                    if (p2pml.hlsjs.Engine.isSupported()) {
                      const config = {
                        segments: {
                          swarmId: this.$store.getters.getP2PConfig.p2pgroup
                        },
                        loader: {
                          trackerAnnounce: process.env.VUE_APP_P2PML_TRACKER
                        }
                      };
                      this.p2pengine = new p2pml.hlsjs.Engine(config);
                      window.engine = this.p2pengine;
                      this.$store.getters.getVideoJSOptions.html5.hlsjsConfig = {
                        liveSyncDurationCount: 2, // To have at least 7 segments in queue
                        loader: this.p2pengine.createLoaderClass()
                      };

                      p2pml.hlsjs.initVideoJsHlsJsPlugin();
                      if (this.$store.getters.getVideodebug) { //da definire e salvare
                        let file = document.createElement("link");
                        file.rel = "stylesheet";
                        file.href = "./css/p2p/p2p-graph.css";
                        document.head.appendChild(file);
                        this.$loadScript("./lib/p2p/rickshaw.min.js").then(() => {
                          this.$loadScript("./lib/p2p/p2p-graph.js").then(() => {
                            this.$loadScript("./lib/p2p/p2p-graph-init.js").then(() => {
                              resolve(true);
                            }, error => {
                              reject(error);
                            });
                          }, error => {
                            reject(error);
                          });
                        }, error => {
                          reject(error);
                        });
                      } else {
                        console.log("To enable P2P debug add p2p_debug=true parameter");
                        resolve(true);
                      }
                    }
                  }, error => {
                    reject(error);
                  });
                }, error => {
                  reject(error);
                });
              }, error => {
                reject(error);
              });
              break;
            default:
              resolve(true);
              break;
          }
        } else {
          resolve(true);
        }
      });
    },
    onTimeUpdate: function() {
      let currentTime = this.player.currentTime();
      //On-demand
      if (this.$store.getters.getCuePoints) {
        let cuePoint = this.findCuepoint(currentTime);
        if (
          cuePoint
          &&
          (
            !this.$store.getters.getCuePoint.time
            ||
            this.$store.getters.getCuePoint.time != cuePoint.time
          )
        ) {
          this.$store.commit("setCuePoint", cuePoint);
        }
      }
    },
    onReady: function() {
      if (this.$store.getters.getIsRestart) {
        setTimeout(() => {
          if (this.player.paused()) this.player.play();
        }, 1000);
      }
      functions.sendParentPlayerEvent("ready");
    },
    findCuepoint: function(arg_currentTime) {
      let cuePoint = null;
      for (let pt = 0; pt < this.$store.getters.getCuePoints.length; pt++) {
        let cuePoint_item = this.$store.getters.getCuePoints[pt];
        if (cuePoint_item.time < arg_currentTime) {
          cuePoint = cuePoint_item;
        } else {
          break;
        }
      }
      return cuePoint;
    }
  },
  computed: {
    getStateVideodebug: function() {
      return this.$store.getters.getVideodebug;
    },
    cmp_skin_class() {
      const embedClass = window.location !== window.parent.location && window.parent[0]?.name === "fidogroupIframe" ? "embedded" : "standalone";
      const skinClass = this.$store.getters.getSkin ? "vjs-" + this.$store.getters.getSkin : "vjs-default-skin";
      return `${embedClass} ${skinClass}`;
    }
  }
};
</script>


<style scoped>
.player {
  z-index: 2;
  height: 100vh;
  width: 100vw;
  margin: 0;
  padding: 0;
  background-color: transparent;
}

.video-js {
  width: 100%;
  height: 100%;
  background-color: transparent !important;
}

.centered-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%)
}
</style>
